import { InputProps } from '.'

type BaseInputCompatibleProps = Omit<InputProps, 'type'> & {
  type?: InputProps['type']
}

export const getBaseInputProps = <T extends BaseInputCompatibleProps>(props: T) => {
  const {
    active: _active,
    className: _className,
    containerClassName: _containerClassName,
    errorMessage: _errorMessage,
    focused: _focused,
    hasBlankError: _hasBlankError,
    icon: _icon,
    iconOnClick: _iconOnClick,
    iconStyle: _iconStyle,
    iconToTheRight: _iconToTheRight,
    label: _label,
    labelClassName: _labelClassName,
    onClick: _onClick,
    options: _options,
    prefix: _prefix,
    suffix: _suffix,
    tooltipContent: _tooltipContent,
    wrapperClassName: _wrapperClassName,
    ...baseInputProps
  } = props

  return baseInputProps
}
